import { render } from "./SocialSheet.vue?vue&type=template&id=6168daa0&scoped=true"
import script from "./SocialSheet.vue?vue&type=script&lang=js"
export * from "./SocialSheet.vue?vue&type=script&lang=js"

import "./SocialSheet.vue?vue&type=style&index=0&id=6168daa0&scoped=true&lang=css"
import "./SocialSheet.vue?vue&type=style&index=1&id=6168daa0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6168daa0"]])

export default __exports__